import CharacterMessage from "./components/CharacterMessage";
import UserMessage from "./components/UserMessage";


const CharacterMessageSwitcher = (props) => {
  const { message = {} } = props;

  const { extra = {} } = message;
  return extra?.isUser ? <UserMessage message={message} {...props} /> : <CharacterMessage message={message} {...props} />;

};

export default CharacterMessageSwitcher;
